"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireWildcard(require("react"));

var _avatar = _interopRequireDefault(require("@identitybuilding/idb-react-ui-elements/dist/placeholders/png/avatar.png"));

var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));

var _Contactform = _interopRequireDefault(require("./Contactform"));

var _axios = _interopRequireDefault(require("axios"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Returns the contacts of an enterprise.
var Contacts = function Contacts(_ref) {
  var id = _ref.id,
      lang = _ref.lang,
      persons = _ref.persons,
      setPersons = _ref.setPersons,
      _setSendMail = _ref.setSendMail,
      CaptchaKey = _ref.CaptchaKey;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      form = _useState2[0],
      setForm = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      name = _useState4[0],
      setName = _useState4[1];

  var translate = function translate(e) {
    return (0, _idbReactTranslations["default"])(e, lang);
  };

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      contacts = _useState6[0],
      setContacts = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = _slicedToArray(_useState7, 2),
      index = _useState8[0],
      setIndex = _useState8[1];

  (0, _react.useEffect)(function () {
    var getContacts = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var contact_persons_model;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                contact_persons_model = require('../models/ContactPersonModel')["default"];
                _context.next = 3;
                return _axios["default"].get("https://management.100procentlokaal.be/core/api/business/".concat(id, "/persons/?lang=").concat(lang)).then(function (res) {
                  setContacts(contact_persons_model(res.data, lang));
                  setPersons(contact_persons_model(res.data, lang));
                })["catch"](function (error) {
                  return console.log(error);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getContacts() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (persons.length === 0) {
      getContacts();
    } else {
      setContacts(persons);
    }
  }, []); // this is most temporarly code as the model of contacts will change

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "contacts"
  }, form && /*#__PURE__*/_react["default"].createElement("div", {
    className: "contact_form_wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Contactform["default"], {
    CaptchaKey: CaptchaKey,
    mailInfo: contacts[index],
    id: id,
    name: name,
    lang: lang,
    close: function close() {
      return setForm(false);
    },
    setSendMail: function setSendMail(e) {
      return _setSendMail(e);
    }
  })), contacts.map(function (contact, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: "contact",
      onClick: function onClick() {
        return setIndex(index);
      }
    }, /*#__PURE__*/_react["default"].createElement("figure", null, /*#__PURE__*/_react["default"].createElement("img", {
      alt: "Avatar contact",
      src: contact.avatar ? contact.avatar : _avatar["default"]
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "contactInfo"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "contactName"
    }, contact.name), /*#__PURE__*/_react["default"].createElement("span", {
      className: "contactRole"
    }, contact.functionTitle), contact.telephone ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "contactPhone"
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: "Phone"
    }), contact.telephone ? contact.telephone : '', /*#__PURE__*/_react["default"].createElement("br", null)) : '', contact.mobile_phone ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "contactPhone"
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: "Cellphone"
    }), contact.mobile_phone ? contact.mobile_phone : '') : '', contact.fax ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "contactPhone"
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: "Fax"
    }), contact.fax) : '', contact.irea ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "contactPhone"
    }, /*#__PURE__*/_react["default"].createElement("b", {
      className: "icon"
    }, "BIV: "), " ", contact.irea) : '', contact.irea ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "contactPhone"
    }, " ", /*#__PURE__*/_react["default"].createElement("b", null, "BIV:"), " ", contact.irea) : '', contact.email ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "contactPhone mail"
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: "Mail"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "email"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      target: "_blank",
      rel: "noopener",
      onClick: function onClick() {
        setName(contact.name), setForm(true);
      }
    }, translate('contact_me'), "!"))) : '', contact.appointment ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "contactPhone mail"
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: "Calendar"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "email"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      style: {
        color: 'var(--sub)'
      },
      target: "_blank",
      rel: "noopener",
      href: contact.appointment
    }, translate('make_appointment')))) : ''), /*#__PURE__*/_react["default"].createElement("div", {
      className: "contact_socialMedias"
    }, contact.social_media.slice(0, 5).map(function (res, index) {
      return /*#__PURE__*/_react["default"].createElement("a", {
        key: index,
        href: res.value,
        target: "_blank",
        rel: "noopener"
      }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        className: res.name,
        name: res.name.substring(0, 1).toUpperCase() + res.name.substring(1)
      }));
    })), contact.social_media.length > 5 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "contact_socialMedias second"
    }, contact.social_media.slice(5).map(function (res, index) {
      return /*#__PURE__*/_react["default"].createElement("a", {
        key: index,
        href: res.value,
        target: "_blank",
        rel: "noopener"
      }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        className: res.name,
        name: res.name.substring(0, 1).toUpperCase() + res.name.substring(1)
      }));
    })));
  }));
};

var _default = Contacts;
exports["default"] = _default;